export default {
  name: "nftLucky",
  data() {
    return {
      currentIndex: 0,
      timer: null,
      speed: 50,
      totalSteps: 0,
      maxSteps: 0,
      order: [0, 1, 2, 5, 8, 7, 6, 3],
      // 顺时针索引
      highlightIndex: null,
      // 当前高亮项（从0-8）
      winningIndex: 6,
      // ✅ 中奖项：真实格子索引（不是顺时针顺序里的位置）
      showPopup: false // ✅ 控制弹窗显示
    };
  },

  methods: {
    startSpin() {
      if (this.timer) return;
      const fastRounds = 4; // 快速转几圈
      const slowRounds = 3; // 最后慢速转两圈
      const targetPos = this.order.findIndex(i => i === this.winningIndex); // 中奖在顺时针中的位置

      this.totalSteps = 0;
      this.speed = 30; // 起始速度
      this.currentIndex = 0;
      this.maxSteps = (fastRounds + slowRounds) * this.order.length + targetPos;
      this.timer = setInterval(this.runSpin, this.speed);
    },
    runSpin() {
      const items = this.order;
      this.currentIndex = (this.currentIndex + 1) % items.length;
      this.highlightIndex = items[this.currentIndex];
      this.totalSteps++;
      const slowDownStart = this.maxSteps - this.order.length * 2; // 慢速开始点
      const stepsLeft = this.maxSteps - this.totalSteps;

      // ❗ 减速阶段：线性变慢
      if (this.totalSteps >= slowDownStart) {
        // 每步增加一点速度（越靠近结束越慢）
        this.speed += 30;
      }

      // 到达目标，结束
      if (this.totalSteps >= this.maxSteps) {
        clearInterval(this.timer);
        this.timer = null;
        setTimeout(() => {
          this.showPopup = true;
        }, 500);
        return;
      }

      // 更新下一个 interval
      clearInterval(this.timer);
      this.timer = setInterval(this.runSpin, this.speed);
    }
  }
};